import { ModalConstant } from '../constants';

const initialState = {};

export default (state = initialState, action) => {
  const { payload: { data, name } = {}, type } = action;
  switch (type) {
    case ModalConstant.CLOSE_MODAL:
      return { [name]: false };
    case ModalConstant.OPEN_MODAL:
      return { [name]: data };
    default:
      return state;
  }
};
